import { history } from '@umijs/max';
import type { AppInitialState } from '../types';
import { convertMenuRouteToMenuDataItem } from '../utils/iconMapper';
import { AvatarDropdown, AvatarName } from '@/components';
import Google2FAModalWrapper from './Google2FAModalWrapper';

interface AppLayoutProps {
    initialState: AppInitialState;
    setInitialState: (state: AppInitialState | ((prev: AppInitialState) => AppInitialState)) => void;
}

// 创建布局配置的函数
export const createAppLayout = ({ initialState, setInitialState }: AppLayoutProps): any => {
    // 页面变化时的路由保护
    const handlePageChange = () => {
        const { location } = history;
        const loginPath = '/user/login';
        // 如果没有登录，重定向到 login
        if (!initialState?.currentUser && location.pathname !== loginPath) {
            history.push(loginPath);
        }
    };

    return {
        avatarProps: {
            title: <AvatarName />,
            render: (_: any, avatarChildren: any) => {
                return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
            },
        },
        onPageChange: handlePageChange,
        // 从服务端请求菜单数据
        menuDataRender: () => {
            try {
                // 直接返回已缓存的菜单数据，并转换为兼容的类型
                const menuData = initialState?.currentUserMenu || [];

                // 转换类型以兼容 Ant Design Pro
                const convertedMenuData = menuData.map(convertMenuRouteToMenuDataItem);

                return convertedMenuData;
            } catch (error) {
                console.error('Failed to get menu data:', error);
                return [];
            }
        },
        bgLayoutImgList: [
            {
                src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
                left: 85,
                bottom: 100,
                height: '303px',
            },
            {
                src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr',
                bottom: -68,
                right: -45,
                height: '303px',
            },
            {
                src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
                bottom: 0,
                left: 0,
                width: '331px',
            },
        ],
        links: [],
        menuHeaderRender: undefined,
        childrenRender: (children: any) => {
            return (
                <>
                    {children}
                    {/* 谷歌验证码绑定弹窗 */}
                    <Google2FAModalWrapper
                        initialState={initialState}
                        setInitialState={setInitialState}
                    />
                </>
            );
        },
        ...initialState?.settings,
    };
};

// 保持向后兼容的默认导出
export default createAppLayout;
